export const groupsDataUpdated = {
  A: {
    teams: ["México", "Sudáfrica", "Corea", "República Checa"],
    days: [
      {
        dateText: "Jueves 11 de junio de 2026",
        matches: [
          { id: "A1", home: "México", away: "Sudáfrica", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "MEX", away_flag: "ZAF", locked: false, venue: "Estadio Ciudad de México", phase: "Fase de Grupos" },
          { id: "A2", home: "Corea", away: "República Checa", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "KOR", away_flag: "CZE", venue: "Estadio Guadalajara", phase: "Fase de Grupos" },
        ],
      },
      {
        dateText: "Jueves 18 de junio de 2026",
        matches: [
          { id: "A3", home: "República Checa", away: "Sudáfrica", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "CZE", away_flag: "ZAF", venue: "Estadio Atlanta", phase: "Fase de Grupos" },
          { id: "A4", home: "México", away: "Corea", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "MEX", away_flag: "KOR", venue: "Estadio Guadalajara", phase: "Fase de Grupos" },
        ],
      },
      {
        dateText: "Miércoles 24 de junio de 2026",
        matches: [
          { id: "A5", home: "República Checa", away: "México", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "CZE", away_flag: "MEX", venue: "Estadio Ciudad de México", phase: "Fase de Grupos" },
          { id: "A6", home: "Sudáfrica", away: "Corea", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "ZAF", away_flag: "KOR", venue: "Estadio Monterrey", phase: "Fase de Grupos" },
        ],
      },
    ],
  },
  B: {
    teams: ["Canadá", "Bosnia", "Qatar", "Suiza"],
    days: [
      {
        dateText: "Viernes 12 de junio de 2026",
        matches: [
          { id: "B1", home: "Canadá", away: "Bosnia", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "CAN", away_flag: "BIH", venue: "Estadio de Toronto", phase: "Fase de Grupos" }
        ],
      },
      {
        dateText: "Sábado 13 de junio de 2026",
        matches: [
          { id: "B2", home: "Qatar", away: "Suiza", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "QAT", away_flag: "SUI", venue: "Estadio de la Bahía de San Francisco", phase: "Fase de Grupos" }
        ],
      },
      {
        dateText: "Jueves 18 de junio de 2026",
        matches: [
          { id: "B3", home: "Suiza", away: "Bosnia", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "SUI", away_flag: "BIH", venue: "Estadio Los Ángeles", phase: "Fase de Grupos" },
          { id: "B4", home: "Canadá", away: "Qatar", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "CAN", away_flag: "QAT", venue: "Estadio BC Place Vancouver", phase: "Fase de Grupos" },
        ],
      },
      {
        dateText: "Miércoles 24 de junio de 2026",
        matches: [
          { id: "B5", home: "Suiza", away: "Canadá", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "SUI", away_flag: "CAN", venue: "Estadio BC Place Vancouver", phase: "Fase de Grupos" },
          { id: "B6", home: "Bosnia", away: "Qatar", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "BIH", away_flag: "QAT", venue: "Estadio de Seattle", phase: "Fase de Grupos" },
        ],
      },
    ],
  },
  C: {
    teams: ["Brasil", "Marruecos", "Haití", "Escocia"],
    days: [
      {
        dateText: "Sábado 13 de junio de 2026",
        matches: [
          { id: "C1", home: "Brasil", away: "Marruecos", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "BRA", away_flag: "MAR", venue: "Estadio Nueva York/Nueva Jersey", phase: "Fase de Grupos" },
          { id: "C2", home: "Haití", away: "Escocia", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "HAI", away_flag: "SCO", venue: "Estadio Boston", phase: "Fase de Grupos" },
        ],
      },
      {
        dateText: "Viernes 19 de junio de 2026",
        matches: [
          { id: "C3", home: "Escocia", away: "Marruecos", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "SCO", away_flag: "MAR", venue: "Estadio Boston", phase: "Fase de Grupos" },
          { id: "C4", home: "Brasil", away: "Haití", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "BRA", away_flag: "HAI", venue: "Estadio Filadelfia", phase: "Fase de Grupos" },
        ],
      },
      {
        dateText: "Miércoles 24 de junio de 2026",
        matches: [
          { id: "C5", home: "Brasil", away: "Escocia", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "BRA", away_flag: "SCO", venue: "Estadio Miami", phase: "Fase de Grupos" },
          { id: "C6", home: "Marruecos", away: "Haití", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "MAR", away_flag: "HAI", venue: "Estadio Atlanta", phase: "Fase de Grupos" },
        ],
      },
    ],
  },
  D: {
    teams: ["EE.UU.", "Paraguay", "Australia", "Turquía"],
    days: [
      {
        dateText: "Viernes 12 de junio de 2026",
        matches: [
          { id: "D1", home: "EE.UU.", away: "Paraguay", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "USA", away_flag: "PAR", venue: "Estadio Los Ángeles", phase: "Fase de Grupos" }
        ],
      },
      {
        dateText: "Sábado 13 de junio de 2026",
        matches: [
          { id: "D2", home: "Australia", away: "Turquía", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "AUS", away_flag: "TUR", venue: "Estadio BC Place Vancouver", phase: "Fase de Grupos" }
        ],
      },
      {
        dateText: "Viernes 19 de junio de 2026",
        matches: [
          { id: "D3", home: "EE.UU.", away: "Australia", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "USA", away_flag: "AUS", venue: "Estadio de Seattle", phase: "Fase de Grupos" },
          { id: "D4", home: "Turquía", away: "Paraguay", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "TUR", away_flag: "PAR", venue: "Estadio de la Bahía de San Francisco", phase: "Fase de Grupos" },
        ],
      },
      {
        dateText: "Jueves 25 de junio de 2026",
        matches: [
          { id: "D5", home: "Turquía", away: "EE.UU.", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "TUR", away_flag: "USA", venue: "Estadio Los Ángeles", phase: "Fase de Grupos" },
          { id: "D6", home: "Paraguay", away: "Australia", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "PAR", away_flag: "AUS", venue: "Estadio de la Bahía de San Francisco", phase: "Fase de Grupos" },
        ],
      },
    ],
  },
  E: {
    teams: ["Alemania", "Curazao", "C. de Marfil", "Ecuador"],
    days: [
      {
        dateText: "Domingo 14 de junio de 2026",
        matches: [
          { id: "E1", home: "Alemania", away: "Curazao", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "GER", away_flag: "CUW", venue: "Estadio Houston", phase: "Fase de Grupos" },
          { id: "E2", home: "C. de Marfil", away: "Ecuador", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "CIV", away_flag: "ECU", venue: "Estadio Filadelfia", phase: "Fase de Grupos" },
        ],
      },
      {
        dateText: "Sábado 20 de junio de 2026",
        matches: [
          { id: "E3", home: "Alemania", away: "C. de Marfil", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "GER", away_flag: "CIV", venue: "Estadio de Toronto", phase: "Fase de Grupos" },
          { id: "E4", home: "Ecuador", away: "Curazao", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "ECU", away_flag: "CUW", venue: "Estadio Kansas City", phase: "Fase de Grupos" }
        ],
      },
      {
        dateText: "Jueves 25 de junio de 2026",
        matches: [
          { id: "E5", home: "Curazao", away: "C. de Marfil", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "CUW", away_flag: "CIV", venue: "Estadio Filadelfia", phase: "Fase de Grupos" },
          { id: "E6", home: "Ecuador", away: "Alemania", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "ECU", away_flag: "GER", venue: "Estadio Nueva York/Nueva Jersey", phase: "Fase de Grupos" },
        ],
      },
    ],
  },
  F: {
    teams: ["Países Bajos", "Japón", "Suecia", "Túnez"],
    days: [
      {
        dateText: "Domingo 14 de junio de 2026",
        matches: [
          { id: "F1", home: "Países Bajos", away: "Japón", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "NED", away_flag: "JPN", venue: "Estadio Dallas", phase: "Fase de Grupos" },
          { id: "F2", home: "Suecia", away: "Túnez", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "SWE", away_flag: "TUN", venue: "Estadio Monterrey", phase: "Fase de Grupos" },
        ],
      },
      {
        dateText: "Sábado 20 de junio de 2026",
        matches: [
          { id: "F3", home: "Países Bajos", away: "Suecia", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "NED", away_flag: "SWE", venue: "Estadio Houston", phase: "Fase de Grupos" },
          { id: "F4", home: "Túnez", away: "Japón", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "TUN", away_flag: "JPN", venue: "Estadio Monterrey", phase: "Fase de Grupos" },
        ],
      },
      {
        dateText: "Jueves 25 de junio de 2026",
        matches: [
          { id: "F5", home: "Japón", away: "Suecia", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "JPN", away_flag: "SWE", venue: "Estadio Dallas", phase: "Fase de Grupos" },
          { id: "F6", home: "Túnez", away: "Países Bajos", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "TUN", away_flag: "NED", venue: "Estadio Kansas City", phase: "Fase de Grupos" },
        ],
      },
    ],
  },
  G: {
    teams: ["Bélgica", "Egipto", "RI de Irán", "Nueva Zelanda"],
    days: [
      {
        dateText: "Lunes 15 de junio de 2026",
        matches: [
          { id: "G1", home: "Bélgica", away: "Egipto", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "BEL", away_flag: "EGY", venue: "Estadio de Seattle", phase: "Fase de Grupos" },
          { id: "G2", home: "RI de Irán", away: "Nueva Zelanda", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "IRN", away_flag: "NZL", venue: "Estadio Los Ángeles", phase: "Fase de Grupos" },
        ],
      },
      {
        dateText: "Domingo 21 de junio de 2026",
        matches: [
          { id: "G3", home: "Bélgica", away: "RI de Irán", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "BEL", away_flag: "IRN", venue: "Estadio Los Ángeles", phase: "Fase de Grupos" },
          { id: "G4", home: "Nueva Zelanda", away: "Egipto", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "NZL", away_flag: "EGY", venue: "Estadio BC Place Vancouver", phase: "Fase de Grupos" },
        ],
      },
      {
        dateText: "Viernes 26 de junio de 2026",
        matches: [
          { id: "G5", home: "Egipto", away: "RI de Irán", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "EGY", away_flag: "IRN", venue: "Estadio de Seattle", phase: "Fase de Grupos" },
          { id: "G6", home: "Nueva Zelanda", away: "Bélgica", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "NZL", away_flag: "BEL", venue: "Estadio BC Place Vancouver", phase: "Fase de Grupos" },
        ],
      },
    ],
  },
  H: {
    teams: ["España", "Cabo Verde", "Arabia Saudí", "Uruguay"],
    days: [
      {
        dateText: "Lunes 15 de junio de 2026",
        matches: [
          { id: "H1", home: "España", away: "Cabo Verde", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "ESP", away_flag: "CPV", venue: "Estadio Atlanta", phase: "Fase de Grupos" },
          { id: "H2", home: "Arabia Saudí", away: "Uruguay", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "KSA", away_flag: "URU", venue: "Estadio Miami", phase: "Fase de Grupos" },
        ],
      },
      {
        dateText: "Domingo 21 de junio de 2026",
        matches: [
          { id: "H3", home: "España", away: "Arabia Saudí", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "ESP", away_flag: "KSA", venue: "Estadio Atlanta", phase: "Fase de Grupos" },
          { id: "H4", home: "Uruguay", away: "Cabo Verde", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "URU", away_flag: "CPV", venue: "Estadio Miami", phase: "Fase de Grupos" },
        ],
      },
      {
        dateText: "Viernes 26 de junio de 2026",
        matches: [
          { id: "H5", home: "Cabo Verde", away: "Arabia Saudí", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "CPV", away_flag: "KSA", venue: "Estadio Houston", phase: "Fase de Grupos" },
          { id: "H6", home: "Uruguay", away: "España", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "URU", away_flag: "ESP", venue: "Estadio Guadalajara", phase: "Fase de Grupos" },
        ],
      },
    ],
  },
  I: {
    teams: ["Francia", "Senegal", "Irak", "Noruega"],
    days: [
      {
        dateText: "Martes 16 de junio de 2026",
        matches: [
          { id: "I1", home: "Francia", away: "Senegal", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "FRA", away_flag: "SEN", venue: "Estadio Nueva York/Nueva Jersey", phase: "Fase de Grupos" },
          { id: "I2", home: "Irak", away: "Noruega", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "IRQ", away_flag: "NOR", venue: "Estadio Boston", phase: "Fase de Grupos" },
        ],
      },
      {
        dateText: "Lunes 22 de junio de 2026",
        matches: [
          { id: "I3", home: "Francia", away: "Irak", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "FRA", away_flag: "IRQ", venue: "Estadio Filadelfia", phase: "Fase de Grupos" },
          { id: "I4", home: "Noruega", away: "Senegal", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "NOR", away_flag: "SEN", venue: "Estadio Nueva York/Nueva Jersey", phase: "Fase de Grupos" },
        ],
      },
      {
        dateText: "Viernes 26 de junio de 2026",
        matches: [
          { id: "I5", home: "Senegal", away: "Irak", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "SEN", away_flag: "IRQ", venue: "Estadio Toronto", phase: "Fase de Grupos" },
          { id: "I6", home: "Noruega", away: "Francia", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "NOR", away_flag: "FRA", venue: "Estadio Boston", phase: "Fase de Grupos" },
        ],
      },
    ],
  },
  J: {
    teams: ["Argentina", "Argelia", "Austria", "Jordania"],
    days: [
      {
        dateText: "Martes 16 de junio de 2026",
        matches: [
          { id: "J1", home: "Argentina", away: "Argelia", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "ARG", away_flag: "ALG", venue: "Estadio Kansas City", phase: "Fase de Grupos" },
          { id: "J2", home: "Austria", away: "Jordania", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "AUT", away_flag: "JOR", venue: "Estadio de la Bahía de San Francisco", phase: "Fase de Grupos" },
        ],
      },
      {
        dateText: "Lunes 22 de junio de 2026",
        matches: [
          { id: "J3", home: "Argentina", away: "Austria", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "ARG", away_flag: "AUT", venue: "Estadio Dallas", phase: "Fase de Grupos" },
          { id: "J4", home: "Jordania", away: "Argelia", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "JOR", away_flag: "ALG", venue: "Estadio de la Bahía de San Francisco", phase: "Fase de Grupos" },
        ],
      },
      {
        dateText: "Sábado 27 de junio de 2026",
        matches: [
          { id: "J5", home: "Argelia", away: "Austria", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "ALG", away_flag: "AUT", venue: "Estadio Kansas City", phase: "Fase de Grupos" },
          { id: "J6", home: "Jordania", away: "Argentina", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "JOR", away_flag: "ARG", venue: "Estadio Dallas", phase: "Fase de Grupos" },
        ],
      },
    ],
  },
  K: {
    teams: ["Portugal", "RD Congo", "Uzbekistán", "Colombia"],
    days: [
      {
        dateText: "Miércoles 17 de junio de 2026",
        matches: [
          { id: "K1", home: "Portugal", away: "RD Congo", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "POR", away_flag: "COD", venue: "Estadio Houston", phase: "Fase de Grupos" },
          { id: "K2", home: "Uzbekistán", away: "Colombia", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "UZB", away_flag: "COL", venue: "Estadio Ciudad de México", phase: "Fase de Grupos" },
        ],
      },
      {
        dateText: "Martes 23 de junio de 2026",
        matches: [
          { id: "K3", home: "Portugal", away: "Uzbekistán", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "POR", away_flag: "UZB", venue: "Estadio Houston", phase: "Fase de Grupos" },
          { id: "K4", home: "Colombia", away: "RD Congo", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "COL", away_flag: "COD", venue: "Estadio Guadalajara", phase: "Fase de Grupos" },
        ],
      },
      {
        dateText: "Sábado 27 de junio de 2026",
        matches: [
          { id: "K5", home: "Colombia", away: "Portugal", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "COL", away_flag: "POR", venue: "Estadio Miami", phase: "Fase de Grupos" },
          { id: "K6", home: "RD Congo", away: "Uzbekistán", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "COD", away_flag: "UZB", venue: "Estadio Atlanta", phase: "Fase de Grupos" },
        ],
      },
    ],
  },
  L: {
    teams: ["Inglaterra", "Croacia", "Ghana", "Panamá"],
    days: [
      {
        dateText: "Miércoles 17 de junio de 2026",
        matches: [
          { id: "L1", home: "Inglaterra", away: "Croacia", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "ENG", away_flag: "CRO", venue: "Estadio Dallas", phase: "Fase de Grupos" },
          { id: "L2", home: "Ghana", away: "Panamá", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "GHA", away_flag: "PAN", venue: "Estadio de Toronto", phase: "Fase de Grupos" },
        ],
      },
      {
        dateText: "Martes 23 de junio de 2026",
        matches: [
          { id: "L3", home: "Inglaterra", away: "Ghana", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "ENG", away_flag: "GHA", venue: "Estadio Boston", phase: "Fase de Grupos" },
          { id: "L4", home: "Panamá", away: "Croacia", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "PAN", away_flag: "CRO", venue: "Estadio de Toronto", phase: "Fase de Grupos" },
        ],
      },
      {
        dateText: "Sábado 27 de junio de 2026",
        matches: [
          { id: "L5", home: "Panamá", away: "Inglaterra", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "PAN", away_flag: "ENG", venue: "Estadio Nueva York/Nueva Jersey", phase: "Fase de Grupos" },
          { id: "L6", home: "Croacia", away: "Ghana", homeScore: "", awayScore: "", homeFairPlay: 0, awayFairPlay: 0, home_flag: "CRO", away_flag: "GHA", venue: "Estadio Filadelfia", phase: "Fase de Grupos" },
        ],
      },
    ],
  },
};